module.exports = __webpack_public_path__ + "resource/img/Blue.d212ba99.png";